import { v4 as uuidv4 } from 'uuid'
import { initialAddTitles, initialAddItems } from "./items"
import { verifyRules } from './pptosProfits'
import moment from 'moment'

export const initialCreateBudgetNew = async (initialParams = null, rules = []) => {

    const newRule = await verifyRules(rules, initialParams?.id_area_negocio)

    return {
        id: 0,
        numero: '000000',
        referencia: '',
        estado_negocio: 'por aprobar',
        id_cliente: 0,
        cliente: '',
        contacto_id: 0,
        contacto_nombre: null,
        contacto_email: null,
        id_area_negocio: initialParams?.id_area_negocio,
        area_negocio: initialParams?.nombre_area,
        id_ejecutivo: initialParams?.uid || null,
        ejecutivo: '',
        sub_total: 0,
        descuento: 0,
        descuento_porcentaje: 0,
        total_cliente: 0,
        total_gasto_p: 0,
        margen_gasto_p: 0,
        total_utilidad_p: 0,
        margen_utilidad_p: 0,
        total_utilidad_r: 0,
        margen_utilidad_r: 0,
        id_moneda: initialParams?.id_moneda,
        moneda: initialParams?.moneda,
        valor_tipo_cambio: initialParams?.valor_tipo_cambio,
        separacion_miles: initialParams?.separacion_miles,
        separacion_decimales: initialParams?.separacion_decimales,
        simbolo: initialParams?.simbolo,
        id_forma_pago: initialParams?.id_forma_pago_venta,
        forma_pago: initialParams?.forma_pago_venta,
        fecha_vencimiento: moment(new Date()).add(5, 'days').format('YYYY-MM-DD'),
        fecha_asignacion: new Date(),
        observaciones: initialParams?.observaciones_ventas || '',
        no_incluye: initialParams?.no_incluye || '',
        terminos_condiciones: initialParams?.terminos_condiciones || '',
        total_impuesto: 0,
        id_tipo_documento: initialParams?.id_tipo_documento_venta || 1,
        porcentaje_impuesto: initialParams?.imp_venta_porcentaje || 18,
        total: 0,
        afecto: true,
        validacion_id_validador: null,
        validacion_estado: '',
        validacion_nota: null,
        validacion_id_regla: newRule?.id,
        validacion_rentabilidad_optima: newRule?.percent,
        validacion_descripcion_regla: newRule?.description,
        items: [],
        cant_items: 0,
        reading_mode: false,
        is_template: false,
        nombre_columna_dias: null,
        template_mode: false,
        template_id: null,
        area_construida: null,
        medida_construida: null,
        margen_sobre_costo: initialParams?.margen_sobre_costo || null,
    }
}

export const initialCreateBudgetNewFromCrm = async (initialParams = null, rules = []) => {

    const newRule = await verifyRules(rules, initialParams?.id_area_negocio)

    return {
        id: 0,
        numero: '000000',
        referencia: initialParams?.info_crm?.referencia || '',
        estado_negocio: 'por aprobar',
        id_cliente: initialParams?.info_crm?.id_contacto || 0,
        id_oportunidad: initialParams?.info_crm?.id,
        cliente: '',
        contacto_id: 0,
        contacto_nombre: null,
        contacto_email: null,
        id_area_negocio: initialParams?.id_area_negocio,
        area_negocio: initialParams?.nombre_area,
        id_ejecutivo: initialParams?.uid || null,
        ejecutivo: '',
        sub_total: 0,
        descuento: 0,
        descuento_porcentaje: 0,
        total_cliente: 0,
        total_gasto_p: 0,
        margen_gasto_p: 0,
        total_utilidad_p: 0,
        margen_utilidad_p: 0,
        total_utilidad_r: 0,
        margen_utilidad_r: 0,
        id_moneda: initialParams?.id_moneda,
        moneda: initialParams?.moneda,
        valor_tipo_cambio: initialParams?.valor_tipo_cambio,
        separacion_miles: initialParams?.separacion_miles,
        separacion_decimales: initialParams?.separacion_decimales,
        simbolo: initialParams?.simbolo,
        id_forma_pago: initialParams?.id_forma_pago_venta,
        forma_pago: initialParams?.forma_pago_venta,
        fecha_vencimiento: moment(new Date()).add(5, 'days').format('YYYY-MM-DD'),
        fecha_asignacion: new Date(),
        observaciones: initialParams?.observaciones_ventas || '',
        no_incluye: initialParams?.no_incluye || '',
        terminos_condiciones: initialParams?.terminos_condiciones || '',
        total_impuesto: 0,
        id_tipo_documento: initialParams?.id_tipo_documento_venta || 1,
        porcentaje_impuesto: initialParams?.imp_venta_porcentaje || 18,
        total: 0,
        afecto: true,
        validacion_id_validador: null,
        validacion_estado: '',
        validacion_nota: null,
        validacion_id_regla: newRule?.id,
        validacion_rentabilidad_optima: newRule?.percent,
        validacion_descripcion_regla: newRule?.description,
        items: [],
        cant_items: 0,
        reading_mode: false,
        is_template: false,
        nombre_columna_dias: null,
        template_mode: false,
        template_id: null,
        area_construida: null,
        medida_construida: null,
        margen_sobre_costo: initialParams?.margen_sobre_costo || null,
        ubicacion: initialParams?.info_crm?.ubicacion || '',
    }
}

export const initialCreateBudgetDuplicate = async (currentData = null) => {

    const { items: itemsOd, info_crm = null } = currentData

    const getNewItems = async (currentItems, newIdTitle) => {
        let newItemsByTitle = []

        for (let x = 0; x < currentItems.length; x++) {
            let currentItem = currentItems[x]
            const newIdItem = uuidv4()

            const sorting = currentItem.sorting

            const params = {
                newId: newIdItem,
                idTitle: newIdTitle,
                sorting: sorting,
                data: currentItem,
                categoryId: null
            }

            const newItem = await initialAddItems(params)

            newItemsByTitle = [
                ...newItemsByTitle,
                newItem
            ]

        }

        return newItemsByTitle

    }

    let newItemsAll = []
    for (let i = 0; i < itemsOd.length; i++) {
        const currentTitle = itemsOd[i]
        const currentItems = currentTitle.items

        const newIdTitle = uuidv4()
        const newTitle = await initialAddTitles(newIdTitle, currentTitle)

        // get Items
        const newItemsByTitle = await getNewItems(currentItems, newIdTitle)

        newItemsAll = [
            ...newItemsAll,
            {
                ...newTitle,
                items: newItemsByTitle
            }
        ]
    }

    const oportId = info_crm?.id || null
    const referencia = info_crm ? info_crm.referencia : `COPIA ${currentData?.referencia}`
    const clienteId = info_crm ? info_crm.id_contacto : (currentData?.id_cliente || 0)
    const clienteName = info_crm ? '' : (currentData?.cliente || '')
    const contactId = info_crm ? 0 : (currentData?.contacto_id || 0)
    const contactName = info_crm ? null : (currentData?.contacto_nombre || null)
    const contactEmail = info_crm ? null : (currentData?.contacto_email || null)

    return {
        id: 0,
        numero: '000000',
        referencia: referencia,
        estado_negocio: 'por aprobar',
        id_cliente: parseInt(clienteId),
        id_oportunidad: oportId,
        cliente: clienteName,
        contacto_id: parseInt(contactId),
        contacto_nombre: contactName,
        contacto_email: contactEmail,
        id_area_negocio: currentData?.id_area_negocio || 0,
        area_negocio: currentData?.area_negocio || '',
        id_ejecutivo: currentData?.id_ejecutivo || 0,
        ejecutivo: currentData?.ejecutivo || '',
        sub_total: currentData?.sub_total || 0,
        descuento: currentData?.descuento || 0,
        descuento_porcentaje: currentData?.descuento_porcentaje || 0,
        total_cliente: currentData?.total_cliente || 0,
        total_gasto_p: currentData?.total_gasto_p || 0,
        margen_gasto_p: currentData?.margen_gasto_p || 0,
        total_utilidad_p: currentData?.total_utilidad_p || 0,
        margen_utilidad_p: currentData?.margen_utilidad_p || 0,
        total_utilidad_r: currentData?.total_utilidad_r || 0,
        margen_utilidad_r: currentData?.margen_utilidad_r || 0,
        id_moneda: currentData?.id_moneda || 4,
        moneda: currentData?.moneda || 'dolares',
        valor_tipo_cambio: currentData?.valor_tipo_cambio,
        separacion_miles: currentData?.separacion_miles || '.',
        separacion_decimales: currentData?.separacion_decimales || ',',
        simbolo: currentData?.simbolo || '$',
        id_forma_pago: currentData?.id_forma_pago || 0,
        forma_pago: currentData?.forma_pago || '',
        fecha_vencimiento: moment(new Date()).add(5, 'days').format('YYYY-MM-DD'),
        fecha_asignacion: new Date(),
        observaciones: currentData?.observaciones || '',
        no_incluye: currentData?.no_incluye || '',
        terminos_condiciones: currentData?.terminos_condiciones || '',
        total_impuesto: currentData?.total_impuesto || 0,
        id_tipo_documento: currentData?.id_tipo_documento || 1,
        porcentaje_impuesto: currentData?.porcentaje_impuesto || 18,
        total: currentData?.total || 0,
        afecto: currentData?.afecto || true,
        validacion_estado: currentData?.validacion_estado || null,
        validacion_nota: currentData?.validacion_nota || null,
        validacion_rentabilidad_optima: currentData?.validacion_rentabilidad_optima || null,
        validacion_id_validador: currentData?.validacion_id_validador || null,
        validacion_id_regla: currentData?.validacion_id_regla || null,
        validacion_descripcion_regla: currentData?.validacion_descripcion_regla || null,
        items: newItemsAll,
        cant_items: currentData?.cant_items || 0,
        reading_mode: false,
        is_template: false,
        nombre_columna_dias: currentData?.nombre_columna_dias || null,
        template_mode: currentData?.template_mode || false,
        template_id: currentData?.template_id || null,
        ubicacion: currentData?.ubicacion || null,
        area_construida: currentData?.area_construida || null,
        medida_construida: currentData?.medida_construida || null,
        otras_formas_pago: currentData?.otras_formas_pago || [],
        margen_sobre_costo: currentData?.margen_sobre_costo || null,
    }

}

export const initialCreatePptoGasto = async () => {
    return {
        id: 0,
        numero: '000000',
        referencia: 'nuevo plan de gasto',
        sub_total: 0,
        total: 0,
        total_gasto_actual: 0,
        margen_gasto_actual: 0,
        total_saldo: 0,
        margen_saldo: 0,
        id_moneda: 4,
        moneda: 'dolares',
        separacion_miles: '.',
        separacion_decimales: ',',
        simbolo: '$',
        items: []
    }
}

export const getItemsSelected = async (titles) => {
    let itemsSelected = []

    for (let i = 0; i < titles.length; i++) {
        const currentTitle = titles[i]
        const filtered = currentTitle.items.filter(it => it.selected === true)

        for (let x = 0; x < filtered.length; x++) {
            itemsSelected = [
                ...itemsSelected,
                filtered[x]
            ]
        }

    }

    return itemsSelected

}
